import { Component, OnInit, Injector, Inject } from '@angular/core';
import { AgencyService } from '../common-theme/api/agency.service';
import { ActivatedRoute } from '@angular/router';
import { ApartmentTypesBaseComponent, ListTrackingService } from './../common-theme/index';
import { Project, BuildingFloor } from '../common-theme/models/index';
import { DOCUMENT } from '@angular/platform-browser';

@Component({
  selector: 'app-buildings',
  templateUrl: './buildings.component.html'
})
export class BuildingsComponent extends ApartmentTypesBaseComponent implements OnInit {
  project: Project;
  buildingFloors: BuildingFloor[];

  constructor(
    injector: Injector,
    public agencyService: AgencyService,
    public route: ActivatedRoute,
    @Inject('WINDOW') public window: any,
    public listTrackingService: ListTrackingService,
    @Inject(DOCUMENT) public document: any
  ) {
    super(injector, agencyService, route, window, document);
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.project = this.route.snapshot.data.project;
    this.setTitle(this.agencyService.agency.name, this.project.name);
    this.buildingFloors = this.route.snapshot.data.building_floors;

    if (this.project.name === 'B11') {
      this.setMetaDescription(
        `Bloc Dream Residence - Ai la dispozitie un complex rezidential inclus intr-o oferta accesibila. Toate criteriile casei tale mult visate.`
      );
    }
    if (this.project.name === 'B12') {
      this.setMetaDescription(
        `Bloc de locuinte Dream Residence - Ai la dispozitie un complex rezidential inclus intr-o oferta accesibila. Toate criteriile casei tale mult visate.`
      );
    }

    if (this.project.name === 'B12' || this.project.name === 'B13') {
      this.buildingFloors.sort((a, b) => {
        if (a.floor_value > b.floor_value)
          return -1;
        if (a.floor_value < b.floor_value)
          return 1;
        return 0;
      });

      this.buildingFloors.push(this.buildingFloors.shift());
    } else if (this.project.name === 'B11') {
      this.buildingFloors = this.buildingFloors.reverse();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/buildings/buildings.component.ts